export default "__VITE_ASSET__4cab9bbc__"